
import "../../../assets/css/material-dashboard.css";
import "../../../assets/css/material-dashboard.css.map";
import "../../../assets/css/nucleo-icons.css";
import "../../../assets/css/nucleo-svg.css";
import "../../../assets/css/material-dashboard.min.css";
import "./SignUp.css";
import toast, { Toaster } from 'react-hot-toast';
import * as yup from 'yup';
import { Button, Form } from 'react-bootstrap';
import { useAppDispatch } from "../../../hooks/redux/hooks";
// import { useAppSelector } from "../../../hooks/redux/hooks";
import { adminSignUp } from "src/store/auth/authSlice";
import { ISignUpCredentials } from "src/store/auth/authApi";
// import { Formik, Field, ErrorMessage } from 'formik';
import * as formik from "formik"
import { useNavigate } from "react-router-dom";

const SignUpPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    // const loginData = useAppSelector((state) => state.auth);

    const { Formik } = formik;

    const validationSchema = yup.object().shape({
        // name: yup.string().required("Please enter your name!"),
        email: yup.string().matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, "Invalid email address").required("Email is a required field."),
        password: yup.string().required("Password is a required field.").min(8, 'Password must be at least 8 characters'),
    });
    const initialValues = {
        name: '',
        email: '',
        password: '',
    };

    const handleFormSubmit = (formInput: any): void => {
        // console.log(formInput);
        const formData = new FormData();
        formData.append('name', formInput.name);
        formData.append('email', formInput.email);
        formData.append('password', formInput.password);
        formData.append('deviceID', "ajnddf");
        formData.append("devicePlatform", "hbdkfd");

        const signUpCredentials: ISignUpCredentials = {

            name: formInput.name,
            email: formInput.email,
            password: formInput.password,
        };

        dispatch(adminSignUp(signUpCredentials)).then((result) => {

            if (result?.payload?.status_code === 201) {
                toast.success("Account created successfully.",
                    {
                        position: "top-right",
                        duration: 2000
                    }
                )
            }
            if (result?.payload?.status_code === 202) {
                toast.error("Already have an account!",
                    {
                        position: "top-right",
                        duration: 2000
                    }
                )
            }
        });

    }

    return (
        <>
            <main className="main-content  mt-0">
                <Toaster />
                <section>
                    <div className="page-header min-vh-100">
                        <div className="container">
                            <div className="row">
                                <div className="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 start-0 text-center justify-content-center flex-column">
                                    <div className="position-relative h-100 left_bg m-3 px-7 border-radius-lg d-flex flex-column justify-content-center ">
                                        {/* <div className="left_bg"></div> */}
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-5 col-md-7 d-flex flex-column ms-auto me-auto ms-lg-auto me-lg-5">
                                    <div className="card card-plain">
                                        <div className="card-header">
                                            <h4 className="font-weight-bolder">Sign Up</h4>
                                            <p className="mb-0">Enter your email and password to register</p>
                                        </div>
                                        <div className="card-body">
                                            <Formik
                                                validationSchema={validationSchema}
                                                onSubmit={(values) => {

                                                    handleFormSubmit(values)
                                                }}
                                                // onSubmit={handleFormSubmit}
                                                initialValues={initialValues}
                                                validateOnBlur={false}
                                                validateOnChange={false}
                                            >
                                                {({ handleSubmit, handleChange, values, touched, errors }) => (

                                                    <Form noValidate onSubmit={handleSubmit} className='auth-form'>

                                                        <Form.Group className="text-start mb-3 " >
                                                            <Form.Label className="form_label" htmlFor='name'>Name</Form.Label>
                                                            <Form.Control className="input_class" id="name" type='name' name="name" value={values.name}
                                                                onChange={handleChange} isValid={touched.name && !errors.name} isInvalid={!!errors.name} />
                                                            <Form.Control.Feedback type="invalid" className="text-start">
                                                                {errors.name}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group className="text-start mb-3" >
                                                            <Form.Label className="form_label" htmlFor='email'>Email address</Form.Label>
                                                            <Form.Control className="input_class" id="email" type='email' name="email" value={values.email}
                                                                onChange={handleChange} isValid={touched.email && !errors.email} isInvalid={!!errors.email} />
                                                            <Form.Control.Feedback type="invalid" className="text-start">
                                                                {errors.email}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group className="text-start mb-3" >
                                                            <Form.Label className="form_label" htmlFor='password'>Password</Form.Label>
                                                            <Form.Control className="input_class" id="password" type='password' name="password" value={values.password}
                                                                onChange={handleChange} isValid={touched.password && !errors.password} isInvalid={!!errors.password} />
                                                            <Form.Control.Feedback type="invalid" className="text-start">
                                                                {errors.password}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Button as="button" variant='btn btn-lg bg-gradient-primary btn-lg w-100 mt-4 mb-0' type='submit'>
                                                            Sign Up
                                                        </Button>

                                                    </Form>

                                                )}
                                            </Formik>
                                        </div>
                                        <div className="card-footer text-center pt-0 px-lg-2 px-1">
                                            <p className="mb-2 text-sm mx-auto">
                                                Already have an account?
                                                <a onClick={() => navigate("/sign-in")} className="text-primary text-gradient font-weight-bold">Sign in</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            {/* <!--   Core JS Files   --> */}
            <script src="../assets/js/core/popper.min.js"></script>
            <script src="../assets/js/core/bootstrap.min.js"></script>
            <script src="../assets/js/plugins/perfect-scrollbar.min.js"></script>
            <script src="../assets/js/plugins/smooth-scrollbar.min.js"></script>

        </>
    )
}

export default SignUpPage;